import { React, useEffect, useState } from "react";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
} from "../../../../../src/Pages/styledElements";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  DatePicker,
} from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePickerY } from "../../../../../src/Pages/pageStyled";
import moment from "moment";
import {
  getMultistageProdOrderDetails,
  getMultistageProdStockDetails,
} from "../../../../Services/productionPlanningServices";
import {
  lengthUnit,
  weightUnit,
} from "../../../../Utils/Constant/MeasurementUnitList";
import { useAsync } from "react-use";
import { toHandlePOName } from "../../../../Utils/helper/helper";
const { Option } = Select;

const OrderAndStockDetails = (props) => {
  const [form] = Form.useForm();
  const [details, setDetails] = useState();
  const [reel_sheet_arr, set_reel_sheet_arr] = useState([]);
  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

  useEffect(() => {
    form.resetFields();
    if (props.orderType == "order") {
      if (props.id) {
        getMultistageProdOrderDetails(props.id)
          .then((response) => {
            setDetails(response.data.data);            
            set_reel_sheet_arr([...response.data.data.reels,...response.data.data.sheets]);
            // console.log([...response.data.data.reels,...response.data.data.sheets]);
            // console.log(response.data.data);
          })
          .catch((error) => console.log(error));
      }
    } else {
      if (props.id) {
        getMultistageProdStockDetails(props.id)
          .then((response) => {
            setDetails(response.data.data);
            set_reel_sheet_arr([...response.data.data.reels,...response.data.data.sheets]);
            // console.log(response.data.data);
          })
          .catch((error) => console.log(error));
      }
    }
    return () => setDetails();
  }, [props]);

  const showProductionStatus = (status) => {
    return capitalize(
      status === "open"
        ? "Not Mapped"
        : status === "cancel"
        ? "Cancelled"
        : status
    );
  };

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  return details ? (
    <RightDrawerSidebar
      title={
        props.orderType == "order"
          ? `Order - ${details?.number}`
          : `Stock - ${details?.number}`
      }
      subtitle={props.orderType == "order" ? `PO - ${toHandlePOName(details?.po)}` : ""}
      visible={props.visible}
      onClose={() => {
        props.onCloseOrderDrawer();
        form.resetFields();
      }}
    >
      <RightDrawerContainer>
        {props.orderType == "order" ? (
          <div className="resetPassForm removePadLeft">
            <DetailFields className="marginBtnP">
              <HaberForm>
                <Form
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                >
                  <div className="drawerField" style={{ marginTop: "-15px" }}>
                    <div className="titleWithText">
                      <h5>Order Type</h5>
                      <p>Order can be of reel or sheet type</p>
                    </div>
                    <Form.Item
                      name="Order type"
                      rules={[{ required: true }]}
                      className=""
                      initialValue={capitalize(details.type)}
                    >
                      <Input disabled placeholder="Order Type" />
                    </Form.Item>
                    <p style={{ marginTop: "-6px" }}></p>
                  </div>
                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Order Dimension</h5>
                      <p>
                        {details.type === "reel" ? (
                          <>The width of the order</>
                        ) : (
                          <>The width and length of the order</>
                        )}
                      </p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={details.type !== "reel" ? 8 : 14}>
                        <div className="boxFormType">
                          <Form.Item
                            name="width"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details.width}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="Width" disabled />
                          </Form.Item>{" "}
                          <p>Width</p>
                        </div>
                      </Col>
                      {details.type !== "reel" && (
                        <Col span={8}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="length"
                              rules={[
                                {
                                  required:
                                    details.type !== "reel" ? true : false,
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                  message:
                                    "Upto 2 decimal point values is accepted",
                                },
                              ]}
                              className="dBlock"
                              initialValue={details?.length}
                              style={{ marginBottom: "0px" }}
                            >
                              <Input disabled />
                            </Form.Item>{" "}
                            <p>Length</p>
                          </div>
                        </Col>
                      )}
                      <Col span={details.type !== "reel" ? 7 : 9}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            name="dimension-unit"
                            rules={[{ required: true }]}
                            className="dBlock"
                            initialValue={
                              details?.units?.width
                                ? lengthUnit[
                                    details?.units?.width
                                  ]?.displayName?.toUpperCase()
                                : "CM"
                            }
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="unit" disabled />
                          </Form.Item>{" "}
                          <p style={{ paddingLeft: "5px" }}>Unit</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Order Quantity</h5>
                      <p>The ordered quantity details of the order</p>
                    </div>
                    {details.quantity_type != "weight" ? (
                      <Form.Item
                        name="orderQty"
                        rules={[{ required: true }]}
                        className=""
                        initialValue={
                          details.type == "sheet"
                            ? details.no_of_sheets
                            : details.no_of_reel_sheet
                        }
                      >
                        <Input disabled placeholder="Order Quantity" />
                      </Form.Item>
                    ) : (
                      <div>
                        <Form.Item
                          name="orderQty"
                          rules={[{ required: true }]}
                          className=""
                          initialValue={details?.weight?.toFixed(3)}
                        >
                          <Input disabled placeholder="Order Quantity" />
                        </Form.Item>
                        <div
                          style={{
                            marginTop: "-56px",
                            marginLeft:
                              weightUnit[details?.units?.weight]?.displayName ==
                              "US - Ton"
                                ? "216px"
                                : weightUnit[details?.units?.weight]
                                    ?.displayName == "ton" ||
                                  weightUnit[details?.units?.weight]
                                    ?.displayName == "kg"
                                ? "317px"
                                : "325px",
                            position: "relative",
                            fontFamily: "var(--sf-pro-text)",
                            color: "#a19f9d",
                          }}
                        >
                          {weightUnit[details?.units?.weight]?.displayName}
                        </div>
                        <p style={{ marginTop: "27px" }}></p>
                      </div>
                    )}
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Produced Quantity</h5>
                      <p>The produced quantity details of the order</p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={12} style={{ maxWidth: "49%" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name="system_qty"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.system_weight?.toFixed(3)}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="System Quantity" disabled />
                          </Form.Item>{" "}
                          <div
                            style={{
                              marginTop: "-31px",
                              marginLeft:
                                weightUnit[details?.units?.weight]
                                  ?.displayName == "US - Ton"
                                  ? "116px"
                                  : weightUnit[details?.units?.weight]
                                      ?.displayName == "ton" ||
                                    weightUnit[details?.units?.weight]
                                      ?.displayName == "kg"
                                  ? "145px"
                                  : "155px",
                              position: "relative",
                              fontFamily: "var(--sf-pro-text)",
                              color: "#a19f9d",
                            }}
                          >
                            {weightUnit[details?.units?.weight]?.displayName}
                          </div>
                          <p style={{ marginTop: "9px" }}>System Quantity</p>
                        </div>
                      </Col>
                      <Col span={12} style={{ maxWidth: "49%" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name="physical_qty"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.produced_weight?.toFixed(3)}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="Physical Quantity" disabled />
                          </Form.Item>{" "}
                          <div
                            style={{
                              marginTop: "-31px",
                              marginLeft:
                                weightUnit[details?.units?.weight]
                                  ?.displayName == "US - Ton"
                                  ? "116px"
                                  : weightUnit[details?.units?.weight]
                                      ?.displayName == "ton" ||
                                    weightUnit[details?.units?.weight]
                                      ?.displayName == "kg"
                                  ? "145px"
                                  : "155px",
                              position: "relative",
                              fontFamily: "var(--sf-pro-text)",
                              color: "#a19f9d",
                            }}
                          >
                            {weightUnit[details?.units?.weight]?.displayName}
                          </div>
                          <p style={{ marginTop: "9px" }}>Physical Quantity</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Customer & Consingee</h5>
                      <p>The customer and consingee who purchase order</p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={12} style={{ maxWidth: "49%" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name="customer"
                            rules={[]}
                            className="dBlock"
                            initialValue={details?.customer}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="Cx Alias" disabled />
                          </Form.Item>{" "}
                          <p style={{ marginTop: "1px" }}>Customer</p>
                        </div>
                      </Col>
                      <Col span={12} style={{ maxWidth: "49%" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name="consignee"
                            rules={[]}
                            className="dBlock"
                            initialValue={details?.consignee}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="CNEE Alias" disabled />
                          </Form.Item>{" "}
                          <p style={{ marginTop: "1px" }}>Consignee</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Delivery Date</h5>
                      <p>Date when order needs to be delivered</p>
                    </div>
                    <div className="boxFormType">
                      <DatePickerY>
                        <Form.Item
                          name="Date"
                          initialValue={moment(
                            details.delivery_date,
                            "YYYY-MM-DD"
                          )}
                        >
                          <DatePicker format={"DD-MM-YYYY"} disabled />
                        </Form.Item>
                      </DatePickerY>
                    </div>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>
                        {details.type != "sheet"
                          ? "Produced Reels"
                          : "Produced Sheets"}
                      </h5>
                      <p>
                        The production details of the order can be viewed here
                      </p>
                    </div>
                    {details.type != "sheet" ? (
                      <div className="prod-reelset">
                        {reel_sheet_arr?.map((item, index) => (
                          <ProductionSet>
                            <div className="prodset-header">
                              <Iconmoon
                                icon={"sheet"}
                                size={28}
                                color="#EA655B"
                              />
                              <div className="prodleft-header">
                                <h4>
                                  {item?.id}
                                  {item?.priority && (
                                    <span dataset="Priority">Priority</span>
                                  )}
                                  {item?.intermediate_reels && (
                                    <span
                                      style={{
                                        color: "#6a6866",
                                        backgroundColor: "#edebe9",
                                        marginTop: "auto",
                                      }}
                                    >
                                      Intermediate
                                    </span>
                                  )}
                                </h4>
                                <label>
                                  Delivery Date:{" "}
                                  {item?.delivery_date
                                    ? moment(item?.delivery_date).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </label>
                              </div>
                            </div>
                            <div className="prodset-body">
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Weight:</h5>
                                  <p>
                                    {item?.weight?.toFixed(3)}{" "}
                                    {item?.units?.weight
                                      ? capitalize(
                                          weightUnit[item?.units?.weight]
                                            ?.displayName
                                        )
                                      : "T"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Size:</h5>
                                  <p>
                                    {item?.reel_size}{" "}
                                    {item?.units?.reel_size
                                      ? lengthUnit[
                                          item?.units?.reel_size
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Length:</h5>
                                  <p>
                                    {item?.reel_length}{" "}
                                    {item?.units?.reel_length
                                      ? lengthUnit[
                                          item?.units?.reel_length
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Order Size:</h5>
                                  <p>
                                    {details?.width}{" "}
                                    {details?.units?.width
                                      ? lengthUnit[
                                          details?.units?.width
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                              </div>
                              <div className="prodset-dt">
                                <h5>Job Card No.:</h5>
                                {(getJCCode(item?.jobcard_code))?.length > 15 ?
                                  (<Tooltip title={getJCCode(item?.jobcard_code)}>
                                    <p>{(getJCCode(item?.jobcard_code)?.slice(0,18))+"..."}</p>
                                  </Tooltip>) : (
                                  <p>{getJCCode(item?.jobcard_code)}</p>
                                )}
                              </div>
                              <div className="prodset-dt">
                                <h5>Parent Reel No.:</h5>
                                <p>{item?.parent_reel}</p>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Rewinding Position:</h5>
                                  <p>{item?.position}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Mill Reel No.:</h5>
                                  <p>{item?.number}</p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Dispatch Date:</h5>
                                  <p>
                                    {item?.dispatch_date
                                      ? moment(item?.dispatch_date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Produced:</h5>
                                  <p>
                                    {item?.actual_weight?.toFixed(3)}{" "}
                                    {item?.units?.actual_weight
                                      ? capitalize(
                                          weightUnit[item?.units?.actual_weight]
                                            ?.displayName
                                        )
                                      : "T"}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="removeStar"
                              style={{ marginTop: "22px" }}
                            >
                              <Row style={{ marginTop: "-15px" }}>
                                <div>
                                  <Col>
                                    <Form.Item
                                      name={`coreWeight${index}`}
                                      className="dBlock"
                                      initialValue={item?.includes_core_weight}
                                    >
                                      <Checkbox
                                        checked={item?.includes_core_weight}
                                        disabled
                                      ></Checkbox>
                                      <span
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "13px",
                                          fontFamily: "var(--sf-pro-display-m)",
                                          color: "#5b5a58",
                                        }}
                                      >
                                        Produced quantity includes core weight
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </div>
                              </Row>
                              <Row
                                style={{
                                  marginTop: "-28px",
                                  marginBottom:
                                    item[index]?.status != "rejected" &&
                                    "-19px",
                                }}
                              >
                                <div>
                                  <Col>
                                    <Form.Item
                                      name={`packagingWeight${index}`}
                                      className="dBlock"
                                      initialValue={
                                        item?.includes_packaging_weight
                                      }
                                    >
                                      <Checkbox
                                        checked={
                                          item?.includes_packaging_weight
                                        }
                                        disabled
                                      ></Checkbox>
                                      <span
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "13px",
                                          fontFamily: "var(--sf-pro-display-m)",
                                          color: "#5b5a58",
                                        }}
                                      >
                                        Produced quantity includes packaging
                                        weight
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </div>
                              </Row>
                            </div>
                            <div
                              className="prodset-footer"
                              style={{ marginTop: "-30px" }}
                            >
                              <label>Production Status</label>
                              <span dataset={showProductionStatus(item.status)}>
                                {showProductionStatus(item.status)}
                              </span>
                            </div>
                            {item.status == "rejected" && (
                              <div
                                className="prodset-footer"
                                style={{ marginTop: "-5px" }}
                              >
                                <label>
                                  Reason:{" "}
                                  {item?.comments?.length
                                    ? item?.comments[item?.comments?.length - 1]
                                    : " "}
                                </label>
                              </div>
                            )}
                          </ProductionSet>
                        ))}
                      </div>
                    ) : (
                      <div className="prod-reelset">
                        {reel_sheet_arr?.map((item) => (
                          <ProductionSet>
                            <div className="prodset-header">
                              <Iconmoon
                                icon={"sheet"}
                                size={28}
                                color="#EA655B"
                              />
                              <div className="prodleft-header">
                                <h4>
                                  {item.id}
                                  {item.priority && (
                                    <span dataset="Priority">Priority</span>
                                  )}
                                  {item.intermediate_reels && (
                                    <span
                                      style={{
                                        color: "#6a6866",
                                        backgroundColor: "#edebe9",
                                        marginTop: "auto",
                                      }}
                                    >
                                      Intermediate
                                    </span>
                                  )}
                                </h4>
                                <label>
                                  Delivery Date:{" "}
                                  {item.delivery_date
                                    ? moment(item?.delivery_date).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </label>
                              </div>
                            </div>
                            <div className="prodset-body">
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Size:</h5>
                                  <p>
                                    {item?.length} x {item?.reel_size}{" "}
                                    {item?.units?.reel_size
                                      ? lengthUnit[
                                          item?.units?.reel_size
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Grain:</h5>
                                  <p>{item?.grain}</p>
                                </div>
                              </div>
                              <div className="prodset-dt">
                                <h5>Quantity in set:</h5>
                                <p>
                                  {item?.weight}{" "}
                                  {item?.units && item?.units?.weight
                                    ? capitalize(
                                        weightUnit[item?.units?.weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                  {" | "}
                                  {item?.no_of_sheets}
                                  {" Sheets"}
                                </p>
                              </div>
                              <div className="prodset-dt">
                                <h5>Produced Quantity:</h5>
                                <p>
                                  {item?.actual_produced_weight}{" "}
                                  {item?.units && item?.units?.actual_produced_weight
                                    ? capitalize(
                                        weightUnit[item?.units?.actual_produced_weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                  {" | "}
                                  {item?.actual_produced_no_of_sheets}
                                  {" Sheets"}
                                </p>
                              </div>
                              <div className="prodset-dt">
                                <h5>Rejected Quantity:</h5>
                                <p>
                                  {item?.rejected_weight}{" "}
                                  {item?.units && item?.units?.rejected_weight
                                    ? capitalize(
                                        weightUnit[item?.units?.rejected_weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                  {" | "}
                                  {item?.rejected_no_of_sheets}
                                  {" Sheets"}
                                </p>
                              </div>
                              <div className="prodset-dt">
                                <h5>Job Card No.:</h5>
                                {(getJCCode(item?.jobcard_code))?.length > 15 ?
                                  (<Tooltip title={getJCCode(item?.jobcard_code)}>
                                    <p>{(getJCCode(item?.jobcard_code)?.slice(0,18))+"..."}</p>
                                  </Tooltip>) : (
                                  <p>{getJCCode(item?.jobcard_code)}</p>
                                )}
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Com. No.:</h5>
                                  <p>{item.combination_no}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Mill Set No.:</h5>
                                  <p>{item?.number}</p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Cutting Position:</h5>
                                  <p>{item?.position}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Dispatch Date:</h5>
                                  <p>
                                    {item?.dispatch_date
                                      ? moment(item?.dispatch_date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="prodset-footer">
                              <label>Production Status</label>
                              <span
                                dataset={showProductionStatus(item?.status)}
                              >
                                {showProductionStatus(item?.status)}
                              </span>
                            </div>
                            {item?.status == "rejected" && (
                              <div
                                className="prodset-footer"
                                style={{ marginTop: "-5px" }}
                              >
                                <label>
                                  Reason:{" "}
                                  {item?.comments?.length
                                    ? item?.comments[item?.comments?.length - 1]
                                    : " "}
                                </label>
                              </div>
                            )}
                          </ProductionSet>
                        ))}
                      </div>
                    )}
                  </div>
                </Form>
              </HaberForm>
            </DetailFields>
          </div>
        ) : (
          <div className="resetPassForm removePadLeft">
            <DetailFields className="marginBtnP">
              <HaberForm>
                <Form
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                >
                  <div className="drawerField" style={{ marginTop: "-15px" }}>
                    <div className="titleWithText">
                      <h5>Stock Type</h5>
                      <p>Stock can be of reel or sheet type</p>
                    </div>
                    <Form.Item
                      name="Order type"
                      rules={[{ required: true }]}
                      className=""
                      initialValue={capitalize(details.type)}
                    >
                      <Input disabled placeholder="Order Type" />
                    </Form.Item>
                    <p style={{ marginTop: "-6px" }}></p>
                  </div>
                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Stock Dimension</h5>
                      <p>
                        {details.type === "reel" ? (
                          <>The width of the stock</>
                        ) : (
                          <>The width and length of the stock</>
                        )}
                      </p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={details.type !== "reel" ? 8 : 14}>
                        <div className="boxFormType">
                          <Form.Item
                            name="width"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details.width}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="Width" disabled />
                          </Form.Item>{" "}
                          <p>Width</p>
                        </div>
                      </Col>
                      {details.type !== "reel" && (
                        <Col span={8}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="length"
                              rules={[
                                {
                                  required:
                                    details.type !== "reel" ? true : false,
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                  message:
                                    "Upto 2 decimal point values is accepted",
                                },
                              ]}
                              className="dBlock"
                              initialValue={details?.length}
                              style={{ marginBottom: "0px" }}
                            >
                              <Input disabled />
                            </Form.Item>{" "}
                            <p>Length</p>
                          </div>
                        </Col>
                      )}
                      <Col span={details.type !== "reel" ? 7 : 9}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            name="dimension-unit"
                            rules={[{ required: true }]}
                            className="dBlock"
                            initialValue={
                              details?.units?.width
                                ? lengthUnit[
                                    details?.units?.width
                                  ]?.displayName?.toUpperCase()
                                : "CM"
                            }
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="unit" disabled />
                          </Form.Item>{" "}
                          <p style={{ paddingLeft: "5px" }}>Unit</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Stock Quantity</h5>
                      <p>The ordered quantity details of the order</p>
                    </div>
                      <Form.Item
                        name="orderQty"
                        rules={[{ required: true }]}
                        className=""
                        initialValue={details?.weight?.toFixed(3)}
                      >
                        <Input disabled placeholder="Stock Quantity" />
                      </Form.Item>
                      <div
                          style={{
                            marginTop: "-56px",
                            marginLeft:
                              weightUnit[details?.units?.weight]?.displayName ==
                              "US - Ton"
                                ? "216px"
                                : weightUnit[details?.units?.weight]
                                    ?.displayName == "ton" ||
                                  weightUnit[details?.units?.weight]
                                    ?.displayName == "kg"
                                ? "317px"
                                : "325px",
                            position: "relative",
                            fontFamily: "var(--sf-pro-text)",
                            color: "#a19f9d",
                          }}
                        >
                          {weightUnit[details?.units?.weight]?.displayName}
                        </div>
                        <p style={{ marginTop: "27px" }}></p>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Produced Quantity</h5>
                      <p>The produced quantity details of the stock</p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={12} style={{ maxWidth: "49%" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name="system_qty"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.system_weight?.toFixed(3)}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="System Quantity" disabled />
                          </Form.Item>{" "}
                          <div
                            style={{
                              marginTop: "-31px",
                              marginLeft:
                                weightUnit[details?.units?.weight]
                                  ?.displayName == "US - Ton"
                                  ? "116px"
                                  : weightUnit[details?.units?.weight]
                                      ?.displayName == "ton" ||
                                    weightUnit[details?.units?.weight]
                                      ?.displayName == "kg"
                                  ? "145px"
                                  : "155px",
                              position: "relative",
                              fontFamily: "var(--sf-pro-text)",
                              color: "#a19f9d",
                            }}
                          >
                            {weightUnit[details?.units?.weight]?.displayName}
                          </div>
                          <p style={{ marginTop: "9px" }}>System Quantity</p>
                        </div>
                      </Col>
                      <Col span={12} style={{ maxWidth: "49%" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name="physical_qty"
                            rules={[
                              { required: true },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={details?.produced_weight?.toFixed(3)}
                            style={{ marginBottom: "0px" }}
                          >
                            <Input placeholder="Physical Quantity" disabled />
                          </Form.Item>{" "}
                          <div
                            style={{
                              marginTop: "-31px",
                              marginLeft:
                                weightUnit[details?.units?.weight]
                                  ?.displayName == "US - Ton"
                                  ? "116px"
                                  : weightUnit[details?.units?.weight]
                                      ?.displayName == "ton" ||
                                    weightUnit[details?.units?.weight]
                                      ?.displayName == "kg"
                                  ? "145px"
                                  : "155px",
                              position: "relative",
                              fontFamily: "var(--sf-pro-text)",
                              color: "#a19f9d",
                            }}
                          >
                            {weightUnit[details?.units?.weight]?.displayName}
                          </div>
                          <p style={{ marginTop: "9px" }}>Physical Quantity</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>
                        {details.type != "sheet"
                          ? "Produced Reels"
                          : "Produced Sheets"}
                      </h5>
                      <p>
                        The production details of the stock can be viewed here
                      </p>
                    </div>
                    {details.type != "sheet" ? (
                        <div className="prod-reelset">
                        {reel_sheet_arr?.map((item, index) => (
                          <ProductionSet>
                            <div className="prodset-header">
                              <Iconmoon
                                icon={"sheet"}
                                size={28}
                                color="#EA655B"
                              />
                              <div className="prodleft-header">
                                <h4>
                                  {item?.id}
                                  {item?.priority && (
                                    <span dataset="Priority">Priority</span>
                                  )}
                                  {item?.intermediate_reels && (
                                    <span
                                      style={{
                                        color: "#6a6866",
                                        backgroundColor: "#edebe9",
                                        marginTop: "auto",
                                      }}
                                    >
                                      Intermediate
                                    </span>
                                  )}
                                </h4>
                                <label>
                                  Delivery Date:{" "}
                                  {item?.delivery_date
                                    ? moment(item?.delivery_date).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </label>
                              </div>
                            </div>
                            <div className="prodset-body">
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Weight:</h5>
                                  <p>
                                    {item?.weight?.toFixed(3)}{" "}
                                    {item?.units?.weight
                                      ? capitalize(
                                          weightUnit[item?.units?.weight]
                                            ?.displayName
                                        )
                                      : "T"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Size:</h5>
                                  <p>
                                    {item?.reel_size}{" "}
                                    {item?.units?.reel_size
                                      ? lengthUnit[
                                          item?.units?.reel_size
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Length:</h5>
                                  <p>
                                    {item?.reel_length}{" "}
                                    {item?.units?.reel_length
                                      ? lengthUnit[
                                          item?.units?.reel_length
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Stock Size:</h5>
                                  <p>
                                    {details?.width}{" "}
                                    {details?.units?.width
                                      ? lengthUnit[
                                          details?.units?.width
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                              </div>
                              <div className="prodset-dt">
                                <h5>Job Card No.:</h5>
                                {(getJCCode(item?.jobcard_code))?.length > 15 ?
                                  (<Tooltip title={getJCCode(item?.jobcard_code)}>
                                    <p>{(getJCCode(item?.jobcard_code)?.slice(0,18))+"..."}</p>
                                  </Tooltip>) : (
                                  <p>{getJCCode(item?.jobcard_code)}</p>
                                )}
                              </div>
                              <div className="prodset-dt">
                                <h5>Parent Reel No.:</h5>
                                <p>{item?.parent_reel}</p>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Rewinding Position:</h5>
                                  <p>{item?.position}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Mill Reel No.:</h5>
                                  <p>{item?.number}</p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Dispatch Date:</h5>
                                  <p>
                                    {item?.dispatch_date
                                      ? moment(item?.dispatch_date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Produced:</h5>
                                  <p>
                                    {item?.actual_weight?.toFixed(3)}{" "}
                                    {item?.units?.actual_weight
                                      ? capitalize(
                                          weightUnit[item?.units?.actual_weight]
                                            ?.displayName
                                        )
                                      : "T"}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              className="removeStar"
                              style={{ marginTop: "22px" }}
                            >
                              <Row style={{ marginTop: "-15px" }}>
                                <div>
                                  <Col>
                                    <Form.Item
                                      name={`coreWeight${index}`}
                                      className="dBlock"
                                      initialValue={item?.includes_core_weight}
                                    >
                                      <Checkbox
                                        checked={item?.includes_core_weight}
                                        disabled
                                      ></Checkbox>
                                      <span
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "13px",
                                          fontFamily: "var(--sf-pro-display-m)",
                                          color: "#5b5a58",
                                        }}
                                      >
                                        Produced quantity includes core weight
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </div>
                              </Row>
                              <Row
                                style={{
                                  marginTop: "-28px",
                                  marginBottom:
                                    item[index]?.status != "rejected" &&
                                    "-19px",
                                }}
                              >
                                <div>
                                  <Col>
                                    <Form.Item
                                      name={`packagingWeight${index}`}
                                      className="dBlock"
                                      initialValue={
                                        item?.includes_packaging_weight
                                      }
                                    >
                                      <Checkbox
                                        checked={
                                          item?.includes_packaging_weight
                                        }
                                        disabled
                                      ></Checkbox>
                                      <span
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "13px",
                                          fontFamily: "var(--sf-pro-display-m)",
                                          color: "#5b5a58",
                                        }}
                                      >
                                        Produced quantity includes packaging
                                        weight
                                      </span>
                                    </Form.Item>
                                  </Col>
                                </div>
                              </Row>
                            </div>
                            <div
                              className="prodset-footer"
                              style={{ marginTop: "-30px" }}
                            >
                              <label>Production Status</label>
                              <span dataset={showProductionStatus(item.status)}>
                                {showProductionStatus(item.status)}
                              </span>
                            </div>
                            {item.status == "rejected" && (
                              <div
                                className="prodset-footer"
                                style={{ marginTop: "-5px" }}
                              >
                                <label>
                                  Reason:{" "}
                                  {item?.comments?.length
                                    ? item?.comments[item?.comments?.length - 1]
                                    : " "}
                                </label>
                              </div>
                            )}
                          </ProductionSet>
                        ))}
                      </div>
                    ) : (
                        <div className="prod-reelset">
                        {reel_sheet_arr?.map((item) => (
                          <ProductionSet>
                            <div className="prodset-header">
                              <Iconmoon
                                icon={"sheet"}
                                size={28}
                                color="#EA655B"
                              />
                              <div className="prodleft-header">
                                <h4>
                                  {item.id}
                                  {item.priority && (
                                    <span dataset="Priority">Priority</span>
                                  )}
                                  {item.intermediate_reels && (
                                    <span
                                      style={{
                                        color: "#6a6866",
                                        backgroundColor: "#edebe9",
                                        marginTop: "auto",
                                      }}
                                    >
                                      Intermediate
                                    </span>
                                  )}
                                </h4>
                                <label>
                                  Delivery Date:{" "}
                                  {item.delivery_date
                                    ? moment(item?.delivery_date).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </label>
                              </div>
                            </div>
                            <div className="prodset-body">
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Size:</h5>
                                  <p>
                                    {item?.length} x {item?.reel_size}{" "}
                                    {item?.units?.reel_size
                                      ? lengthUnit[
                                          item?.units?.reel_size
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Grain:</h5>
                                  <p>{item?.grain}</p>
                                </div>
                              </div>
                              <div className="prodset-dt">
                                <h5>Quantity in set:</h5>
                                <p>
                                  {item?.weight}{" "}
                                  {item?.units && item?.units?.weight
                                    ? capitalize(
                                        weightUnit[item?.units?.weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                  {" | "}
                                  {item?.no_of_sheets}
                                  {" Sheets"}
                                </p>
                              </div>
                              <div className="prodset-dt">
                                <h5>Produced Quantity:</h5>
                                <p>
                                  {item?.accepted_weight}{" "}
                                  {item?.units && item?.units?.accepted_weight
                                    ? capitalize(
                                        weightUnit[item?.units?.accepted_weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                  {" | "}
                                  {item?.accepted_no_of_sheets}
                                  {" Sheets"}
                                </p>
                              </div>
                              <div className="prodset-dt">
                                <h5>Rejected Quantity:</h5>
                                <p>
                                  {item?.rejected_weight}{" "}
                                  {item?.units && item?.units?.rejected_weight
                                    ? capitalize(
                                        weightUnit[item?.units?.rejected_weight]
                                          ?.displayName
                                      )
                                    : "T"}
                                  {" | "}
                                  {item?.rejected_no_of_sheets}
                                  {" Sheets"}
                                </p>
                              </div>
                              <div className="prodset-dt">
                                <h5>Job Card No.:</h5>
                                {(getJCCode(item?.jobcard_code))?.length > 15 ?
                                  (<Tooltip title={getJCCode(item?.jobcard_code)}>
                                    <p>{(getJCCode(item?.jobcard_code)?.slice(0,18))+"..."}</p>
                                  </Tooltip>) : (
                                  <p>{getJCCode(item?.jobcard_code)}</p>
                                )}
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Com. No.:</h5>
                                  <p>{item.combination_no}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Mill Set No.:</h5>
                                  <p>{item?.number}</p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Cutting Position:</h5>
                                  <p>{item?.position}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Dispatch Date:</h5>
                                  <p>
                                    {item?.dispatch_date
                                      ? moment(item?.dispatch_date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="prodset-footer">
                              <label>Production Status</label>
                              <span
                                dataset={showProductionStatus(item?.status)}
                              >
                                {showProductionStatus(item?.status)}
                              </span>
                            </div>
                            {item?.status == "rejected" && (
                              <div
                                className="prodset-footer"
                                style={{ marginTop: "-5px" }}
                              >
                                <label>
                                  Reason:{" "}
                                  {item?.comments?.length
                                    ? item?.comments[item?.comments?.length - 1]
                                    : " "}
                                </label>
                              </div>
                            )}
                          </ProductionSet>
                        ))}
                      </div>
                    )}
                  </div>
                </Form>
              </HaberForm>
            </DetailFields>
          </div>
        )}
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};
export default OrderAndStockDetails;
